"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snakeToCapitalizedConverter = void 0;
var capitalize_1 = require("./capitalize");
var snakeToCapitalizedConverter = function (string) {
    return (0, capitalize_1.capitalizeConverter)(string.replace(/_./g, function (x) { return "".concat(' ' + x.toUpperCase()[1]); }));
};
exports.snakeToCapitalizedConverter = snakeToCapitalizedConverter;
//# sourceMappingURL=snakeToCapitalized.js.map